export const TypeDocumentTemplate = ['Cerfa', 'ContratCxpi', 'MissionCxpi', 'ProForma', 'ProFormaAnnexe'] as const

export type TypeDocumentTemplate = (typeof TypeDocumentTemplate)[number]

/* inutilisé
export const TypeDocumentTemplateLibelle: {
  [key in TypeDocumentTemplate]: string
} = {
  Cerfa: 'Générer le CERFA',
  ContratCxpi: 'Générer le Contrat',
  MissionCxpi: 'Générer la lettre de mission',
  ProForma: 'Générer la Proforma',
  ProFormaAnnexe: "Générer l'annexe à la Proforma",
} as const
*/

export const TypeDocumentTemplateUrl: {
  [key in TypeDocumentTemplate]: string
} = {
  Cerfa: '/cerfa',
  ContratCxpi: '/contrattype',
  MissionCxpi: '/lettremission',
  ProForma: '/document',
  ProFormaAnnexe: '/annexe',
} as const

export const TypeDocumentTemplateNomFichier: {
  [key in TypeDocumentTemplate]: string
} = {
  Cerfa: 'cerfa.pdf',
  ContratCxpi: 'contrat.pdf',
  MissionCxpi: 'mission.pdf',
  ProForma: 'proforma.pdf',
  ProFormaAnnexe: 'annexe_proforma.xlsx',
} as const
